import IMask from "imask/esm/imask.js";
import { concatClasses } from "../../../helpers/concatClasses/index.js";
const parseTime = (time, format) => {
  var _a;
  if (format === "24" && time.length !== 5) {
    return void 0;
  }
  if (format === "12" && time.length !== 7) {
    return void 0;
  }
  let [hours, minutes] = time.split(":").map((s) => parseInt(s, 10));
  if (isNaN(hours) || isNaN(minutes)) {
    return void 0;
  }
  if (!validateHoursMinutes(hours, minutes, format)) {
    return void 0;
  }
  if (format === "12") {
    const amPm = (_a = time.match(/[AaPp][Mm]/)) == null ? void 0 : _a[0].toLowerCase();
    if (!amPm) {
      return void 0;
    }
    if (amPm === "pm" && hours < 12) {
      hours += 12;
    } else if (amPm === "am" && hours === 12) {
      hours = 0;
    }
  }
  return { hours, minutes };
};
const validateHoursMinutes = (hours, minutes, format) => {
  if (format === "24") {
    return hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;
  }
  return hours >= 1 && hours <= 12 && minutes >= 0 && minutes <= 59;
};
const timeToString = (time, format) => {
  const { hours, minutes } = time;
  if (format === "24") {
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  }
  const amPm = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;
  return `${hours12.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${amPm}`;
};
const getInputClasses = ({
  dsf_time_format,
  dsf_size,
  dsf_badge,
  dsf_icon_right
}) => {
  const classes = ["min-w-0 flex-auto"];
  if (dsf_time_format === "12") {
    if (dsf_badge) {
      classes.push(
        dsf_size === "medium" ? dsf_icon_right ? "w-172" : "w-152" : dsf_icon_right ? "w-164" : "w-144"
      );
    } else {
      classes.push(
        dsf_size === "medium" ? dsf_icon_right ? "w-120" : "w-100" : dsf_icon_right ? "w-112" : "w-92"
      );
    }
  } else {
    if (dsf_badge) {
      classes.push(
        dsf_size === "medium" ? dsf_icon_right ? "w-152" : "w-132" : dsf_icon_right ? "w-148" : "w-128"
      );
    } else {
      classes.push(
        dsf_size === "medium" ? dsf_icon_right ? "w-100" : "w-80" : dsf_icon_right ? "w-102" : "w-72"
      );
    }
  }
  return concatClasses(classes);
};
const getMaskOptions = (format) => {
  const mask = format === "24" ? "HH{:}mm" : "h{:}mm A";
  return {
    overwrite: true,
    autofix: true,
    mask,
    lazy: false,
    blocks: {
      HH: {
        mask: IMask.MaskedRange,
        placeholderChar: "h",
        from: 0,
        to: 23,
        maxLength: 2
      },
      h: {
        mask: IMask.MaskedRange,
        placeholderChar: "h",
        from: 1,
        to: 12,
        maxLength: 2
      },
      mm: {
        mask: IMask.MaskedRange,
        placeholderChar: "m",
        from: 0,
        to: 59,
        maxLength: 2
      },
      A: {
        mask: IMask.MaskedEnum,
        enum: ["AM", "am", "PM", "pm", "aM", "Am", "pM", "Pm"],
        placeholderChar: "-"
      }
    }
  };
};
export {
  getInputClasses,
  getMaskOptions,
  parseTime,
  timeToString
};
